import { ReactNode } from "react";

// Barre d'actions groupées, affichée dès qu'une ligne est cochée dans un
// tableau. Les actions sont passées en enfants ; le décompte et le bouton de
// désélection sont communs.
function SelectionBar({
  count,
  onClear,
  children,
}: {
  count: number;
  onClear: () => void;
  children: ReactNode;
}) {
  if (count === 0) return null;
  return (
    <div
      className="d-flex flex-wrap align-items-center gap-3 mb-3 p-2"
      style={{ background: "#f1fafb", borderRadius: 6 }}
    >
      <span style={{ fontWeight: 600 }}>
        {count} facture{count > 1 ? "s" : ""} sélectionnée
        {count > 1 ? "s" : ""}
      </span>
      {children}
      <button
        type="button"
        className="btn btn-link text-muted"
        onClick={onClear}
      >
        Désélectionner
      </button>
    </div>
  );
}

export default SelectionBar;
